(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kt-banner-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.__kts) return;
    var track = root.querySelector('[data-kts-track]');
    if (!track) return;
    root.__kts = true;
    var slides = track.children, n = slides.length, dots = root.querySelectorAll('[data-kts-dot]');
    var cur = 0, timer = null, hover = false, visible = true, moved = false;
    var design = !!(window.Shopify && window.Shopify.designMode);
    var auto = root.getAttribute('data-autoplay') === 'true' && n > 1 && !design &&
      !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var iv = parseInt(root.getAttribute('data-interval'), 10) || 4000;

    function width() { return track.clientWidth || 1; }
    function mark(i) {
      cur = i;
      for (var k = 0; k < dots.length; k++) {
        dots[k].classList.toggle('is-on', k === i);
        dots[k].setAttribute('aria-current', k === i ? 'true' : 'false');
      }
    }
    function go(i, instant) {
      if (!n) return;
      i = (i % n + n) % n;
      track.scrollTo({ left: i * width(), behavior: instant ? 'auto' : 'smooth' });
      mark(i);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (!auto) return;
      timer = setInterval(function () {
        if (!root.isConnected) { stop(); return; }
        if (document.hidden || hover || !visible) return;
        go(cur + 1);
      }, iv);
    }
    function user(i) { go(i); start(); }

    root.__ktsGo = go;
    root.__ktsIdx = function () { return cur; };

    var tick = false;
    track.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      requestAnimationFrame(function () {
        tick = false;
        var i = Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / width())));
        if (i !== cur) mark(i);
      });
    }, { passive: true });

    var prev = root.querySelector('[data-kts-prev]'), next = root.querySelector('[data-kts-next]');
    if (prev) prev.addEventListener('click', function () { user(cur - 1); });
    if (next) next.addEventListener('click', function () { user(cur + 1); });
    for (var d = 0; d < dots.length; d++) (function (k) {
      dots[k].addEventListener('click', function () { user(k); });
    })(d);

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); user(cur + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); user(cur - 1); }
    });

    /* mouse drag (touch already swipes natively) */
    var down = false, sx = 0, sl = 0, scale = 1;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
      var r = track.getBoundingClientRect(); scale = r.width ? track.offsetWidth / r.width : 1;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = (e.clientX - sx) * scale;
      if (Math.abs(dx) > 5) { moved = true; track.classList.add('is-drag'); }
      if (moved) track.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) {
        track.classList.remove('is-drag');
        var w = width(), diff = track.scrollLeft - cur * w, i = cur;
        if (diff > w * 0.18) i = cur + 1; else if (diff < -w * 0.18) i = cur - 1;
        user(Math.max(0, Math.min(n - 1, i)));
        setTimeout(function () { moved = false; }, 0);
      }
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

    /* pause while the customer is looking at / touching it */
    root.addEventListener('mouseenter', function () { hover = true; });
    root.addEventListener('mouseleave', function () { hover = false; });
    root.addEventListener('focusin', function () { hover = true; });
    root.addEventListener('focusout', function () { hover = false; });
    root.addEventListener('touchstart', function () { hover = true; }, { passive: true });
    root.addEventListener('touchend', function () { hover = false; start(); }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.2 }).observe(root);
    }
    window.addEventListener('resize', function () { go(cur, true); });

    /* countdown (end time is read as UAE time, UTC+4) */
    var cds = root.querySelectorAll('[data-kts-cd]');
    function parseEnd(s) {
      var m = /^\s*(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/.exec(s || '');
      return m ? Date.UTC(+m[1], +m[2] - 1, +m[3], (+m[4] || 0) - 4, +m[5] || 0) : NaN;
    }
    function two(x) { return (x < 10 ? '0' : '') + x; }
    function tickCd() {
      for (var c = 0; c < cds.length; c++) {
        var el = cds[c];
        if (el.__end === undefined) el.__end = parseEnd(el.getAttribute('data-kts-cd'));
        if (isNaN(el.__end)) { el.hidden = true; continue; }
        var ms = el.__end - Date.now();
        if (ms <= 0) {
          if (!el.__over) {
            el.__over = true;
            var t = document.createElement('strong');
            t.className = 'kts-ended';
            t.textContent = el.getAttribute('data-ended') || '';
            el.innerHTML = '';
            el.appendChild(t);
          }
          continue;
        }
        var sec = Math.floor(ms / 1000);
        var v = { d: Math.floor(sec / 86400), h: Math.floor(sec % 86400 / 3600), m: Math.floor(sec % 3600 / 60), s: sec % 60 };
        for (var k in v) { var b = el.querySelector('[data-u="' + k + '"]'); if (b) b.textContent = k === 'd' ? (v[k] < 10 ? '0' + v[k] : v[k]) : two(v[k]); }
      }
    }
    if (cds.length) {
      tickCd();
      var cdt = setInterval(function () { if (!root.isConnected) { clearInterval(cdt); return; } tickCd(); }, 1000);
    }

    mark(0);
    start();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-kts]').forEach(init);
  }
  window.ktsInitAll = initAll;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target, root = slide.closest && slide.closest('[data-kts]');
    if (!root || !root.__ktsGo) return;
    var list = Array.prototype.slice.call(slide.parentNode.children);
    root.__ktsGo(list.indexOf(slide));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kt-showcase"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__ktShowcase) return;
  window.__ktShowcase = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var JH = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var STILL = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* progress bar under the row */
  function prog(tr) {
    var box = tr.closest('.ktc'); if (!box) return;
    var th = box.querySelector('.kt-prog i'); if (!th) return;
    var bar = th.parentNode, sw = tr.scrollWidth, cw = tr.clientWidth;
    if (sw <= cw + 2) { bar.style.visibility = 'hidden'; return; }
    bar.style.visibility = 'visible';
    th.style.width = (Math.max(0.2, cw / sw) * 100) + '%';
    th.style.left = (tr.scrollLeft / sw * 100) + '%';
  }
  function progAll() { var t = document.querySelectorAll('.kt-track'); for (var i = 0; i < t.length; i++) prog(t[i]); }
  document.addEventListener('scroll', function (e) {
    var t = e.target; if (t && t.classList && t.classList.contains('kt-track')) prog(t);
  }, true);

  /* mouse drag to swipe (touch swipes natively) */
  var drag = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var tr = e.target.closest && e.target.closest('.kt-track'); if (!tr) return;
    var k = tr.offsetWidth ? tr.getBoundingClientRect().width / tr.offsetWidth : 1;
    drag = { tr: tr, x: e.clientX, l: tr.scrollLeft, k: k || 1, m: false };
  });
  window.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.m && Math.abs(dx) > 5) { drag.m = true; drag.tr.classList.add('is-drag'); }
    if (drag.m) drag.tr.scrollLeft = drag.l - dx / drag.k;
  });
  window.addEventListener('pointerup', function () {
    if (!drag) return;
    var d = drag; drag = null; d.tr.classList.remove('is-drag');
    if (d.m) { d.tr.__ktMoved = true; setTimeout(function () { d.tr.__ktMoved = false; }, 60); }
  });
  document.addEventListener('click', function (e) {
    var tr = e.target.closest && e.target.closest('.kt-track');
    if (tr && tr.__ktMoved) { e.preventDefault(); e.stopPropagation(); tr.__ktMoved = false; }
  }, true);

  /* desktop arrows */
  document.addEventListener('click', function (e) {
    var n = e.target.closest && e.target.closest('[data-kt-nav]'); if (!n) return;
    var box = n.closest('.ktc'), tr = box && box.querySelector('.kt-track'); if (!tr) return;
    tr.scrollBy({ left: (+n.getAttribute('data-kt-nav')) * Math.max(200, tr.clientWidth * 0.8), behavior: STILL ? 'auto' : 'smooth' });
  });

  /* add to cart */
  function fly(btn) {
    if (STILL) return;
    var card = btn.closest('.kt-c'), im = card && card.querySelector('.kt-img img');
    var target = document.querySelector('cart-icon') || document.querySelector('[data-kt-cart-target]') || document.querySelector('a[href$="/cart"]');
    if (!im || !target) return;
    var t = target.getBoundingClientRect(), r = btn.getBoundingClientRect();
    if (!t.width || !r.width) return;
    var el = document.createElement('div'); el.className = 'kt-fly';
    el.style.backgroundImage = 'url("' + (im.currentSrc || im.src) + '")';
    document.body.appendChild(el);
    var sx = r.left + r.width / 2 - 20, sy = r.top + r.height / 2 - 20, ex = t.left + t.width / 2 - 20, ey = t.top + t.height / 2 - 20;
    var a = el.animate([
      { transform: 'translate(' + sx + 'px,' + sy + 'px) scale(1)', opacity: 1 },
      { transform: 'translate(' + ((sx + ex) / 2) + 'px,' + (Math.min(sy, ey) + 30) + 'px) scale(.85)', opacity: 1, offset: 0.5 },
      { transform: 'translate(' + ex + 'px,' + ey + 'px) scale(.3)', opacity: 0.6 }
    ], { duration: 700, easing: 'cubic-bezier(.5,0,.3,1)' });
    a.onfinish = function () { el.remove(); };
  }
  function notify(cart, open) {
    var d = document.querySelector('cart-drawer-component[auto-open]');
    if (d && !open) d.removeAttribute('auto-open');
    var ev = new Event('cart:update', { bubbles: true });
    ev.detail = { resource: cart, sourceId: 'kt-showcase', data: { itemCount: cart.item_count, source: 'kt-showcase' } };
    document.dispatchEvent(ev);
    if (d && !open) setTimeout(function () { d.setAttribute('auto-open', ''); }, 60);
  }
  function mark(btn, ok) {
    var box = btn.closest('.ktc'), lbl = btn.querySelector('.kt-lbl');
    if (!ok) { btn.classList.remove('is-err'); void btn.offsetWidth; btn.classList.add('is-err'); return; }
    btn.classList.add('is-done');
    if (lbl) { lbl.__old = lbl.textContent; lbl.textContent = (box && box.getAttribute('data-kt-added')) || 'Added'; }
    var card = btn.closest('.kt-c');
    if (card && box && box.className.indexOf('ktc--pinboard') > -1) { card.classList.remove('kt-swing'); void card.offsetWidth; card.classList.add('kt-swing'); }
    setTimeout(function () {
      btn.classList.remove('is-done');
      if (lbl && lbl.__old) lbl.textContent = lbl.__old;
    }, 1400);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kt-add]');
    if (!b || b.disabled || b.__busy) return;
    e.preventDefault(); b.__busy = true;
    var box = b.closest('.ktc'), open = box && box.getAttribute('data-kt-drawer') === 'true';
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: JH, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-kt-add'), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        mark(b, true); fly(b);
        return fetch(ROOT + 'cart.js', { headers: JH }).then(function (r) { return r.json(); }).then(function (c) { notify(c, open); });
      })
      .catch(function () { mark(b, false); })
      .then(function () { setTimeout(function () { b.__busy = false; }, 900); });
  });

  /* pinboard: cards swing once when they scroll into view */
  function intro() {
    var els = document.querySelectorAll('.ktc--pinboard:not([data-kt-seen])');
    for (var i = 0; i < els.length; i++) (function (el) {
      el.setAttribute('data-kt-seen', '1');
      if (!('IntersectionObserver' in window)) { el.classList.add('kt-in'); return; }
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { el.classList.add('kt-in'); io.disconnect(); }
      }, { threshold: 0.25 });
      io.observe(el);
    })(els[i]);
  }

  function init() { progAll(); intro(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  window.addEventListener('resize', progAll);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
